import React from 'react';
import { Box } from '@mui/material';

const SectionDivider = ({ 
  color = '#3498db', 
  dotSize = 8, 
  lineHeight = 1, 
  spacing = 4,
  showDot = true 
}) => {
  return (
    <Box 
      sx={{ 
        display: 'flex',
        alignItems: 'center',
        my: spacing,
        '&::before, &::after': {
          content: '""',
          flex: 1,
          height: `${lineHeight}px`,
          backgroundColor: color,
        }
      }} 
    >
      {showDot && (
        <Box 
          sx={{ 
            mx: 2,
            width: dotSize,
            height: dotSize,
            borderRadius: '50%',
            backgroundColor: color,
          }} 
        />
      )}
    </Box>
  );
};

export default SectionDivider;
